<template>
  <div class="c-checkbox">
    <label class="c-checkbox__label">
      <input-checkbox name="is_auto_login" />
      <div class="c-checkbox__item">
        <span>{{ text }}</span>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    text: String,
  },
}
</script>
